import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { formatQuery } from "../Utils";
import { FixedAssetRegistryActionTypes } from "./FixedAssetRegistry.type";

export function* fetchAllFixedAssetRegistry(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/fixed-asset-registry?${formatQuery(action)}`
    );
    yield put({
      type: FixedAssetRegistryActionTypes
        .FETCH_ALL_FIXED_ASSET_REGISTRY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: FixedAssetRegistryActionTypes
        .FETCH_ALL_FIXED_ASSET_REGISTRY_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneFixedAssetRegistry(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/fixed-asset-registry/${action.payload}`
    );
    yield put({
      type: FixedAssetRegistryActionTypes
        .FETCH_ONE_FIXED_ASSET_REGISTRY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: FixedAssetRegistryActionTypes
        .FETCH_ONE_FIXED_ASSET_REGISTRY_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllFixedAssetRegistry() {
  yield takeLatest(
    FixedAssetRegistryActionTypes.FETCH_ALL_FIXED_ASSET_REGISTRY,
    fetchAllFixedAssetRegistry
  );
}

export function* watcherFetchOneFixedAssetRegistry() {
  yield takeLatest(
    FixedAssetRegistryActionTypes.FETCH_ONE_FIXED_ASSET_REGISTRY,
    fetchOneFixedAssetRegistry
  );
}
